<template>
  <div>
    <v-btn
            depressed
            color="black"
            style="color: #fecb39;"

            class="mb-3 mr-3"
            v-on:click="dialog=true"
    >IMPORT</v-btn>
    <v-dialog
            v-model="dialog"
            persistent
            max-width="600px"
    >
      <v-card class="mtfont">
        <v-card-title>
          <span>CSV IMPORT</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                      cols="12"
                      sm="12"
              >
                <p>To import colors and formulas, select a csv file.<br><small><a style="color:dodgerblue;">Learn more</a></small></p>
              </v-col>


              <v-col
                      cols="12"
                      sm="12">
                <input type="file" id="file" ref="file" v-on:change="onFileUpload()"/>
              </v-col>

            </v-row>
          </v-container>
          <br>
          <small :style="'color:'+messageColor">{{dialogMessage}}</small>
        </v-card-text>
        <v-card-actions class="mx-2 pb-4">
          <v-spacer></v-spacer>
          <v-btn
                  class="mtfont"
                  color="black"
                  text
                  @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
                  class="mtfont"
                  color="black"
                  style="color: #fecb39;"
                  depressed
                  @click="submitForm"
          >
            Import
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  const graphify = obj => {
    const objKeys = Object.keys(obj);
    let graphString = objKeys.reduce((string, key) => {
      return (string + `${key}: "${obj[key]}",`);
    },'{');
    return (graphString + '}');
  };
  export default {
    name: 'NewFormulaModal',
    props: ['item'],

    data: () => ({
      dialog: false,
      dialogMessage: '',
      file: '',
      fileString: '',
      form: {
        name: '',
        email: '',
        pantoneCode: '',
        colorDescription: '',
        status: '',
        comments: ''
      }
    }),
    computed: {
      messageColor: function () {
        return ~this.dialogMessage.indexOf('Error')? 'red': 'green'
      }
    },
    methods: {
      onFileUpload(event) {
        const self = this;
        this.file = this.$refs.file.files[0];
        if(this.file.type !== "text/csv") {
          this.$refs.file.value = '';
          alert("CSV File Type Only");
        }
        else if (this.file) {
          const reader = new FileReader();
          reader.readAsText(this.file, "UTF-8");
          reader.onload = function (evt) {
            self.fileString = evt.target.result;
            //console.log('FILE', evt.target.result);
          };
          reader.onerror = function (evt) {
            alert("error reading file - " + evt);
          }
        }
      },
      submitForm() {
        //console.log('THIS_FILE', this.fileString);
        this.$store.dispatch('importCsv', this.fileString)
          .then(response => {
            if(response.status === 200) {
              const timeoutCallback = self => () => {
                self.dialogMessage = 'CSV Import Success';
                self.dialog = false;
                location.reload();
              };
              setTimeout(timeoutCallback(this), 1500);
            }
            else {
              const timeoutCallback = self => () => {
                self.dialogMessage = 'CSV Import Failed';
              };
              setTimeout(timeoutCallback(this), 1500);
            }

            return response.json();
          })
          .then(data => { console.error('ERROR', data)});
        /*
        const formObject = {
          name: this.form.name,
          code: this.form.pantoneCode,
          email: this.form.email,
          status: this.form.status,
          comments: this.form.comments
        };
        Object.keys(this.form).forEach(key => this.form[key] = '');
        this.$store.dispatch('submitPantoneRequest', graphify(formObject))
                .then(response => {
                  if(response.status === 200) this.dialogMessage = 'Success! Your update request has been sent.';
                  else this.dialogMessage = 'Error! Something went wrong. For help, contact customer service.';

                  const timeoutCallback = self => () => {
                    self.dialogMessage = '';
                    self.dialog = false;
                  };
                  setTimeout(timeoutCallback(this), 1500);
                });
        */
      }
    }
  }
</script>

<style scoped>
</style>